module.exports = __webpack_public_path__ + "static/media/update event.910ab97b.svg";